import { TILE_SIZE } from '@veriverse/shared';
import { DEV_TILES, DEV_TILESET_NAME } from '@veriverse/map-format';
import type Phaser from 'phaser';

/** Placeholder tiles for the dev map, generated at runtime. */
export function createPlaceholderTextures(scene: Phaser.Scene): void {
  const tiles = Object.values(DEV_TILES).sort((a, b) => a.id - b.id);
  const canvas = scene.textures.createCanvas(DEV_TILESET_NAME, tiles.length * TILE_SIZE, TILE_SIZE);
  if (!canvas) throw new Error('Could not create tileset canvas');
  const ctx = canvas.getContext();
  tiles.forEach((tile, index) => {
    const x = index * TILE_SIZE;
    ctx.fillStyle = tile.color;
    ctx.fillRect(x, 0, TILE_SIZE, TILE_SIZE);
    // 1 px darker edge so individual tiles stay readable.
    ctx.fillStyle = 'rgba(0, 0, 0, 0.12)';
    ctx.fillRect(x, TILE_SIZE - 1, TILE_SIZE, 1);
    ctx.fillRect(x + TILE_SIZE - 1, 0, 1, TILE_SIZE);
  });
  canvas.refresh();
}
